module.exports = __webpack_public_path__ + "static/media/arrow-up.3af876df.svg";